import { LicenseSystemSubscriptionViewModel, LicenseSystem as LicenseSystemViewModel, LicenseType, Productline, License } from 'src/viewModels/LicenseSystem';
import { LicenseSystem as ApiLicenseSystemType, CompleteAddLicenseSystemPayload, CompleteReactivateLicenseSystemPayload, LicenseSystemType, ProductLine as ApiProductLineType } from '../generated/types';

const licenseSystemTypeByAPIType: Map<LicenseSystemType, LicenseType> = new Map([
    [LicenseSystemType.Dongle, 'dongle'],
    [LicenseSystemType.Online, 'online'],
    [LicenseSystemType.Software, 'software'],
]);
const ProductLineTypeByAPIType: Map<ApiProductLineType, Productline> = new Map([
    [ApiProductLineType.Colorserver, 'ColorServer'],
    [ApiProductLineType.Colorproof, 'ColorProof'],
    [ApiProductLineType.Opencolor, 'OpenColor'],
]);

const mapLicensesToViewModel = (source: ApiLicenseSystemType['licenses']) => source!.map(license => {

    const result: License = {
        name: license?.name || '',
        expirationDate: license?.expirationDate || '',
        productline: license?.productLine
            ? ProductLineTypeByAPIType.get(license.productLine)
            : undefined,
        installedApplicationDetails: {
            version: license?.installedApplication?.version || undefined,
            lastSeen: license?.installedApplication?.lastSeenDate || undefined,
        },
        // TODO: After the data migration, expirationDate of the license options will be mandatory.
        licenseOptions: license!.options.map(o => ({ name: o.name, expirationDate: o.expirationDate || undefined })),
    };

    return result;
});

export const mapToLicenseSystemViewModel = (source: Array<ApiLicenseSystemType>) => source.map(licenseSystem => {

    const result: LicenseSystemViewModel = {
        id: licenseSystem.id,
        // i18 Next always needs a string, even if the value is undefined.
        licenseType: (licenseSystem?.licenseSystemType ? licenseSystemTypeByAPIType.get(licenseSystem?.licenseSystemType) : 'undefined') || 'undefined',
        computerName: licenseSystem.computerName || '-',
        isTransferSupported: licenseSystem.isTransferSupported,
        location: licenseSystem.location || '-',
        userName: licenseSystem.admin.username || '-',
        userEmail: licenseSystem.admin.email,
        licenses: licenseSystem.licenses ? mapLicensesToViewModel(licenseSystem.licenses) : [],
        lastSeenDate: licenseSystem.lastSeenDate || undefined,
        hasPendingProcess: licenseSystem.hasPendingProcess ?? false,
        isLicenseSystemUpdateAvailable: !!licenseSystem.isLicenseSystemUpdateAvailable,
        hasActiveSuc: !!licenseSystem.isSucActive,
        cpGo: {
            isLicensed: licenseSystem.cpGo.isLicensed,
            isOnline: licenseSystem.cpGo.isOnline,
        },
    };

    return result;
});


export const mapSubscriptionResponseToViewModel = (response: CompleteAddLicenseSystemPayload | CompleteReactivateLicenseSystemPayload) => {

    const result: LicenseSystemSubscriptionViewModel = {
        data: response.data || undefined,
        error: response.error
            ? { message: response.error.errorMessage ?? undefined, errorType: response.error.errorType as 'AssignedToDifferentOrg' | 'AutomatedLicenseTransferDeactivated' | 'OLSExistsWithDiffSrNo' | 'OLSExistsWithSameSrNo' | 'ReactivationLimitReached' | 'Unknown' }
            : undefined,
        licenseSystemId: response.licenseSystemId ?? undefined,
        messageId: response.messageId,
    };

    return result;

};